import { ArrowChangeDown } from 'components/Icons/ArrowChangeDown'
import { ArrowChangeUp } from 'components/Icons/ArrowChangeUp'
import { HeaderCellWrapper, InfoIconContainer } from 'components/Tokens/TokenTable/TokenRow'
import { MouseoverTooltip } from 'components/Tooltip'
import { useAtomValue } from 'jotai/utils'
import { ReactNode } from 'react'
import { Info } from 'react-feather'
import { useTheme } from 'styled-components/macro'

import { LockSortMethod, sortAscendingAtom, sortMethodAtom, useSetSortMethod } from './state'

const HEADER_DESCRIPTIONS: Record<LockSortMethod, ReactNode | undefined> = {
  [LockSortMethod.NFT_ID]: undefined,
  [LockSortMethod.LOCK_AMOUNT]: undefined,
  [LockSortMethod.VOTING_POWER]: undefined,
  [LockSortMethod.EXPIRES]: undefined,
  [LockSortMethod.EARN]: undefined,
}

export default function HeaderCell({
  category,
  justify,
}: {
  category: LockSortMethod // TODO: change this to make it work for trans
  justify?: string
}) {
  const theme = useTheme()
  const sortAscending = useAtomValue(sortAscendingAtom)
  const handleSortCategory = useSetSortMethod(category)
  const sortMethod = useAtomValue(sortMethodAtom)

  const description = HEADER_DESCRIPTIONS[category]

  return (
    <HeaderCellWrapper onClick={handleSortCategory} justify={justify}>
      {sortMethod === category && (
        <>
          {sortAscending ? (
            <ArrowChangeUp width={16} height={16} color={theme.textSecondary} />
          ) : (
            <ArrowChangeDown width={16} height={16} color={theme.textPrimary} />
          )}
        </>
      )}
      {category}
      {description && (
        <MouseoverTooltip text={description} placement="right">
          <InfoIconContainer>
            <Info width="16px" height="16px" />
          </InfoIconContainer>
        </MouseoverTooltip>
      )}
    </HeaderCellWrapper>
  )
}
